/* ============================================================================
   ADMIN → FORMULAS — galeri (PROTOTAIP DESIGN · 27 Okt 2026, ADMIN SAHAJA)
   ============================================================================
   Arahan user: "display sama mcm kat workspace v4 tu, then bila tekan icon gear baru ada page
   utk edit" + "buat ui design dulu tanpa wired apa-apa or pindahkan code apa2 dari workspace sebenar".

   · Rupa = galeri Workspace v4 (kelas sedia ada s-fgrid / s-fcard / gv2-vtab / gv2-format) — HANYA
     kelas CSS & pemilih Sort/Filter dipinjam; tiada logik Workspace dipindah atau disentuh.
   · Data = utils/formulaAdminContoh.js (contoh). Tiada Firestore, tiada simpanan.
   · Gear pada card → /admin/formulas/:id (FormulaAdminEditView). Card itu sendiri bukan butang.
   · Route '/admin/formulas*' dipagar `isAdmin` (App.jsx). ⚠️ Belum dipagar PIN — prototaip tiada data
     sebenar. Bila disambung ke master prompt sebenar → WAJIB bungkus AdminPinGate.
   · NAK PADAM: fail ini + FormulaAdminEditView.jsx + FormulaAdmin.css + utils/formulaAdminContoh.js
     + 2 route dalam App.jsx + item menu 'adm-formulas' dan padanan '/admin/formulas' dalam StudioShell.
   ========================================================================== */
import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Settings2, Play, Image as ImageIcon, AlignLeft, ArrowUpDown, ListFilter, X } from 'lucide-react';
import '../design/tokens.css';
import { PageHeader, Badge } from '../design/ui';
import { ChipPilih } from './GenerateV2Avatar';
import './GenerateV2Pilot.css';
import './FormulaAdmin.css';
import { GOAL_V2, FORMAT_V2 } from '../utils/generateV2Matlamat';
import { FORMULA_CONTOH, STATUS_FA } from '../utils/formulaAdminContoh';

const IKON_FORMAT = { video: Play, image: ImageIcon, text: AlignLeft };
const SUSUN = [{ id: 'asal', nama: 'Default order' }, { id: 'az', nama: 'A–Z' }];

export default function FormulaAdminView() {
    const navigate = useNavigate();
    const [goalId, setGoalId] = useState('');
    const [formatId, setFormatId] = useState('');
    const [susunId, setSusunId] = useState('asal');

    const kira = useMemo(() => Object.fromEntries(
        ['', ...GOAL_V2.map((g) => g.id)].map((id) => [id, FORMULA_CONTOH.filter((f) => !id || f.goal === id).length]),
    ), []);
    const senarai = useMemo(() => {
        const d = FORMULA_CONTOH.filter((f) => (!goalId || f.goal === goalId) && (!formatId || f.format === formatId));
        return susunId === 'az' ? [...d].sort((a, b) => a.nama.localeCompare(b.nama)) : d;
    }, [goalId, formatId, susunId]);

    const buka = (id) => navigate(`/admin/formulas/${id}`);

    return (
        <div className="sesaat-m-tight" style={{ padding: '26px 28px 48px' }}>
            <PageHeader
                title="Formula Settings"
                subtitle="Every formula customers can pick. Press the gear on a card to edit its master prompt blocks and options."
                sisiTajuk={<Badge tone="warn">Design prototype · sample data</Badge>}
                suisBahasa={false}
            />

            <section className="s-panelbox fma-galeri">
                <div className="gv2-vbar">
                    <div className="gv2-vtabs" role="tablist" aria-label="Goal">
                        {[{ id: '', nama: 'All' }, ...GOAL_V2].map((t) => (
                            <button key={t.id || 'semua'} type="button" role="tab" aria-selected={t.id === goalId} title={t.nota}
                                className={'gv2-vtab' + (t.id === goalId ? ' gv2-vtab--on' : '')} onClick={() => setGoalId(t.id)}>
                                {t.nama}<span>{kira[t.id] ?? 0}</span>
                            </button>
                        ))}
                    </div>
                    <div className="gv2-vbar__alat">
                        <button type="button" className="s-chip" onClick={() => buka('baru')}>
                            <Plus size={14} strokeWidth={2} /><span>New formula</span>
                        </button>
                        <ChipPilih ikon={<ArrowUpDown size={14} strokeWidth={1.8} />} label={SUSUN.find((x) => x.id === susunId)?.nama}
                            pilihan={SUSUN} nilai={susunId} onPilih={setSusunId} lebar={160} kanan />
                        <ChipPilih ikon={<ListFilter size={14} strokeWidth={1.8} />} label={FORMAT_V2.find((x) => x.id === formatId)?.nama || 'Filter'}
                            pilihan={[{ id: '', nama: 'All formats' }, ...FORMAT_V2]} nilai={formatId} onPilih={setFormatId} lebar={160} kanan />
                    </div>
                </div>
                <div className="gv2-vinfo">
                    <span>{senarai.length} formulas</span>
                    {formatId && (
                        <button type="button" className="gv2-vinfo__cip" onClick={() => setFormatId('')} aria-label="Clear format filter">
                            {FORMAT_V2.find((x) => x.id === formatId)?.nama}<X size={11} strokeWidth={2.2} />
                        </button>
                    )}
                </div>

                <div className="s-fgrid">
                    {!goalId && (
                        <button type="button" className="s-fcard s-fcard--new" onClick={() => buka('baru')}>
                            <span className="s-fcard__v"><span className="s-fcard__plus"><Plus size={19} strokeWidth={2} /></span></span>
                            <span className="s-fcard__n">New formula</span>
                            <span className="s-fcard__d">Build from blocks</span>
                        </button>
                    )}
                    {senarai.map((f) => {
                        const Ikon = IKON_FORMAT[f.format];
                        const st = STATUS_FA[f.status];
                        return (
                            <div key={f.id} className="s-fcard fma-kad">
                                <span className="s-fcard__v">
                                    {f.poster
                                        ? <img src={f.poster} alt="" />
                                        : <span className="fma-kad__kosong"><Ikon size={22} strokeWidth={1.5} /><span>{f.nama}</span></span>}
                                    {f.pil && <span className="gv2-pilmedia">{f.pil}</span>}
                                    <span className="gv2-format" title={f.format}><Ikon size={11} strokeWidth={2.2} /></span>
                                    <button type="button" className="fma-gear" title={`Edit ${f.nama}`} aria-label={`Edit ${f.nama}`} onClick={() => buka(f.id)}>
                                        <Settings2 size={13} strokeWidth={2} />
                                    </button>
                                    <span className={`fma-status fma-status--${st.tone}`}>{st.label}</span>
                                </span>
                                <span className="s-fcard__n">
                                    <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{f.nama}</span>
                                    {f.mod === 'classic' && <span className="gv2-tagnama">Classic</span>}
                                </span>
                                <span className="s-fcard__d">{f.nota}</span>
                            </div>
                        );
                    })}
                </div>
                {senarai.length === 0 && <p className="gv2-kosong">No formulas here yet</p>}
            </section>
        </div>
    );
}
